<div class="lp-card">
  @if (canShowHeader) {
    <div class="lp-header" (click)="toggle()">
      <button
        class="lp-toggle-btn d-flex justify-content-between align-items-center"
        type="button"
        [attr.aria-expanded]="!isCollapsed"
      >
        <span>LP Items Details</span>
        <span class="lp-chevron"></span>
      </button>
    </div>
  }

  <div class="lp-collapse-container" [class.show]="!isCollapsed">
    <div class="lp-body">
      <div class="lp-content">
        @for (lpItem of licensePlate?.items; track $index) {
          <div class="row mx-0">
            <div class="col-lg-3 col-md-6 col-sm-12 lp-cell">
              <div class="lp-label">Item Name</div>
              <div class="lp-value">
                {{ getShortProductName(lpItem.product && lpItem.product.name) || 'N/A' }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 lp-cell">
              <div class="lp-label">SKU Code</div>
              <div class="lp-value">
                {{  lpItem.product?.sku || 'N/A' }}
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 lp-cell">
              <div class="lp-label">Department/Category</div>
              <div class="lp-value">
                {{ lpItem.product?.department?.name ?? 'N/A' }} /
                {{ lpItem.product?.category?.name ?? 'N/A' }}
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 lp-cell">
              <div class="lp-label">Item Quantity</div>
              <div class="lp-value">{{ lpItem.quantity }}</div>
            </div>
          </div>

          @if (lpItem.itemSerials && lpItem.itemSerials.length) {
            <div class="lp-serials">
              <div class="lp-label">Item Serials</div>
              <div class="lp-serial-tags">
                @for (serial of lpItem.itemSerials; track serial.id) {
                  <span class="lp-serial-pill">{{ serial.serialNumber?.serialNumber }}</span>
                }
              </div>
            </div>
          }
          <div class="lp-divider"></div>
        }
      </div>
    </div>
  </div>
</div>
